:host {
  display: block;
  margin-top: 8px !important;
  margin-bottom: 28px !important;
}

.#{$prefix}divider {
  position: relative;
  width: 100%;
  height: 1px;
  background-color: $navigation-flyout-divider-bg-color;
}
